module.exports = __webpack_public_path__ + "img/spot2.79330d28.png";